import { TextField, InputAdornment, IconButton } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';
import './SearchBar.css';

interface SearchBarProps {
  searchValue: string;
  setSearchValue: (value: string) => void;
  height?: number;
}

const SearchBar = ({ searchValue, setSearchValue, height = 23 }: SearchBarProps) => {
  const handleClear = () => setSearchValue('');

  const iconSize = (height === 32) ? 24 : 18;

  return (
    <TextField
      variant="outlined"
      placeholder="Type something"
      autoComplete="off"
      value={searchValue}
      onChange={(e) => setSearchValue(e.target.value)}
      className="searchbar-wrapper"
      sx={{
        width: 200,
        height,
        '& .MuiInputBase-root': {
          height,
          minHeight: height,
          paddingRight: '8px',
          boxSizing: 'border-box',
        },
        '& .MuiOutlinedInput-notchedOutline': {
          borderColor: '#ccc',
        },
        '& input': {
          padding: '0 10px',
          height: '100%',
          fontFamily: 'Roboto',
          fontSize: '14px',
          letterSpacing: '0.2px',
          boxSizing: 'border-box',
        },
      }}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            {searchValue ? (
              <IconButton size="small" onClick={handleClear} sx={{ padding: 0 }}>
                <CloseIcon
                  sx={{
                    width: `${iconSize}px !important`,
                    height: `${iconSize}px !important`,
                  }}
                />
              </IconButton>
            ) : (
              <IconButton size="small" sx={{ padding: 0 }}>
                <SearchIcon
                  sx={{
                    width: `${iconSize}px !important`,
                    height: `${iconSize}px !important`,
                  }}
                />
              </IconButton>
            )}
          </InputAdornment>
        ),
      }}
    />
  );
};

export default SearchBar;
